import React from "react";
import { useState } from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, Link } from 'react-router-dom';
import { Document, Page, pdfjs  } from 'react-pdf'

//import axios from 'axios';
import axios_api from "../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';
import ViewDocumentModal from './common/ViewDocumentModal';
import ConfirmationModal from './common/ConfirmationModal';


if (typeof Promise.withResolvers === 'undefined') {
  if (window)
      // @ts-expect-error This does not exist outside of polyfill which this is doing
      window.Promise.withResolvers = function () {
          let resolve, reject;
          const promise = new Promise((res, rej) => {
              resolve = res;
              reject = rej;
          });
          return { promise, resolve, reject };
      };
}

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  //'pdfjs-dist/build/pdf.worker.min.mjs',
  'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.4.168/legacy/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();


export function GetApproveStatus (status) {
  const STATUSES = {
    "NO_CONTRACT": "договор не сгенерирован",
    "DRAFT": "сгенерирован черновик договора",
    "SENT": "договор поступил на утверждение",
    "APPROVED": "договор утвержден",
    "REJECTED": "договор отклонен"
  }
  return STATUSES[status]
}

export function GetSignStatus (status) {
  const STATUSES = {
    "NOT_SIGNED": "не подписан",
    "SELLER_SIGNED": "подписан АСНП",
    "CLIENT_SIGNED": "подписан клиентом",
    "BOTH_SIGNED": "подписан двумя сторонами",
  }
  return STATUSES[status]
}


export default function Order({}) {
  const [uploadStatus, setUploadStatus] = useState(null);
  const [order, setOrder] = useState(Object());
  const [errorMessage, setErrorMessage] = useState(Object())
  const [rejectionComment, setRejectionComment] = useState("");
  // const [groups, setGroups] = useState([]);
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);
  const media_url = useContext(MEDIA_URL);
  const navigate = useNavigate();

  let { orderId } = useParams();
  orderId = Number(orderId);


  React.useEffect(() => {

    let status = axios_api.get(api_url + '/order_upload/' + orderId, {
      headers: {"Authorization": token},
    });

    status.then(
      (result) => {
        let apiReturnedStatus = result.data;
        setUploadStatus(apiReturnedStatus);
        console.log(apiReturnedStatus)
      },
      (error) => {
        console.log(error)
      }
    );

  }, []);

  React.useEffect(() => {

    let order = axios_api.get(api_url + '/manage_order/' + orderId, {
      headers: {"Authorization": token},
    });

    order.then(
      (result) => {
        let apiReturnedOrder = result.data;
        setOrder(apiReturnedOrder);
      },
      (error) => {
        console.log(error)
        setOrder([]);
      }
    );

  }, []);

  //function HandleCommentChange(){
  //  console.log("cc");
  //}

  function HandleReject(order) {
    console.log("rejecting: " + rejectionComment);
    let params = {
      "operation": "reject", 
      "comment": rejectionComment
    }

    axios_api.put(api_url + `/manage_order/` + order.id, params, {
      headers: {"Authorization":token},
    })
    .then(
      (result) => {
        console.log("Order rejected");
        navigate("/");
        navigate(0);
      },
      (error) => {
        console.log(error);
        navigate("/order/" + order.id);
      }
    );
  }

  function GetRejectComment(ticketId) {

    let ticket = axios_api.get(api_url + `/manage_ticket_legal/` + ticketId, {
      headers: {"Authorization": token}
    })
    .then(
      (result) => {
        let approveTicket = result.data;
        let rejectComment = approveTicket.follow_ups[0].comment
        //console.log(rejectComment);
        setRejectionComment(rejectComment);
      },
      (error) => {
        console.log(error);
        //setrejectCommeRt(Object());
      }
    );  
  }

  function HandleApprove(order) {
    let params = {"operation": "approve"}

    axios_api.put(api_url + `/manage_order/` + order.id, params, {
      headers: {"Authorization": token},
    })
    .then(
      (result) => {
        console.log("Order approved");
        navigate("/order/" + order.id);
        navigate(0);
      },
      (error) => {
        console.log(error.response);
        //navigate("/order/" + order.id);
        setErrorMessage(error.response)
      }
    );
  }

  function HandleMarkDocsSigned(order) {
    let params = {"operation": "mark-docs-signed"}

    axios_api.put(api_url + `/manage_order/` + order.id, params, {
      headers: {"Authorization": token},
    })
    .then(
      (result) => {
        console.log("User docs marked signed");
        navigate("/order/" + order.id);
        navigate(0);
      },
      (error) => {
        console.log(error.response);
        //navigate("/order/" + order.id);
        setErrorMessage(error.response)
      }
    );
  }

  function HandleUploadOrder(order) {
    let params = {}

    axios_api.post(api_url + `/order_upload/` + order.id, params, {
      headers: {"Authorization": token},
    })
    .then(
      (result) => {
        console.log("Order uploaded to 1C");
        navigate("/order/" + order.id);
        navigate(0);
      },
      (error) => {
        console.log(error.response);
        //navigate("/order/" + order.id);
        //setErrorMessage(error.response)
      }
    );   
  }

  function HandleCloseErrorMessage() {
    setErrorMessage(Object());
  }

  if (order.approve_status === 'REJECTED' && Object.keys(rejectionComment).length === 0 ) {
    GetRejectComment(order.approve_ticket);
  }

  let approveStatusDisplay = GetApproveStatus(order.approve_status);
  let signStatusDisplay = GetSignStatus(order.sign_status);

  console.log(order)
  return (
    <>
      <h3 className="m-3"><Link to={`/`}>к списку заказов</Link></h3>


      <div className="row">
        <div className="col-10 m-3">
          <div className="card lk-border category-card">
            <div className="card-header text-center">
              <h4 className="m-2">Договор № {order.user ? order.user.username : ""}-{order.year}</h4>
            </div>   
            <div className="card-body p-5">
            <div className="row">
              <div className="col-6 pe-5">  
                <p>Статус:</p>
                <p>
                  {order.approve_status === "SENT" && <span className="fw-semibold">{approveStatusDisplay}</span>}
                  {order.approve_status === "APPROVED" && <span className="text-success fw-semibold">{approveStatusDisplay}</span> }
                  {order.approve_status === "REJECTED" && <span className="text-danger fw-semibold">{approveStatusDisplay}</span> }
                </p> 

                { order.approve_status === 'REJECTED' &&
                  <>
                    <p className="">Комментарий сотрудника АСНП: </p>
                    <p><span className="text-danger">{rejectionComment}</span></p>
                  </>
                }

                <p>
                  {order.sign_status === "NOT_SIGNED" && <span className="fw-semibold">{signStatusDisplay}</span>}
                  {order.sign_status === "SELLER_SIGNED" && <span className="text-success fw-semibold">{signStatusDisplay}</span> }
                  {order.sign_status === "CLIENT_SIGNED" && <span className="fw-semibold">Не подписан АСНП</span> }
                  {order.sign_status === "BOTH_SIGNED" && <span className="text-success fw-semibold">{signStatusDisplay}</span> }
                </p>

                {order.order_form_pdf && 
                  <>
                    <ViewDocumentModal
                      modalId="orderModal"
                      headerText="Бланк заказа"
                      document={order["order_form_pdf"]}
                    />

                    <div className="row">
                      <div className="col-10">
                        <div className="my-2 d-flex align-content-center bg-info bg-opacity-10 rounded border">
                          <p className="m-3 flex-grow-1 align-content-center"><b>Бланк заказа</b></p>
                          <Link className="align-content-center me-3" to={`/order/` + order.id + '/order_form_upload'}>изменить...</Link>
                          <a className="align-content-center" href={media_url + order.order_form_pdf} download>скачать pdf</a>        
                          <button className="m-3 p-2 lk-button" onClick={() => console.log("вызвали модал")} data-bs-toggle="modal" data-bs-target="#orderModal">
                            <p className="m-0">Посмотреть</p>
                          </button> 
                          </div>
                      </div> 
                    </div>  
                  </>
                }

                {order.contract_pdf && 
                  <>
                    <ViewDocumentModal
                      modalId="contractModal"
                      headerText="Договор"
                      document={order["contract_pdf"]}
                    />

                    <div className="row">
                      <div className="col-10">
                        <div className="my-2 d-flex align-content-center bg-info bg-opacity-10 rounded border">
                          <p className="m-3 flex-grow-1 align-content-center"><b>Договор</b></p>
                          <Link className="align-content-center me-3" to={`/order/` + order.id + '/contract_upload'}>изменить...</Link>
                          <a className="align-content-center" href={media_url + order.contract_pdf} download>скачать pdf</a>        
                          <button className="m-3 p-2 lk-button" onClick={() => console.log("вызвали модал")} data-bs-toggle="modal" data-bs-target="#contractModal">
                            <p className="m-0">Посмотреть</p>
                          </button> 
                          </div>
                      </div> 
                    </div>  
                  </> 
                }

                {order.invoice_pdf && 
                  <> 
                    <ViewDocumentModal
                      modalId="invoiceModal"
                      headerText="Счет"
                      document={order["invoice_pdf"]}
                    />

                    <div className="row">
                      <div className="col-10">
                        <div className="my-2 d-flex align-content-center bg-info bg-opacity-10 rounded border">
                          <p className="m-3 flex-grow-1 align-content-center"><b>Счет</b></p>
                          <a className="align-content-center" href={media_url + order.invoice_pdf} download>скачать pdf</a>        
                          <button className="m-3 p-2 lk-button" onClick={() => console.log("вызвали модал")} data-bs-toggle="modal" data-bs-target="#invoiceModal">
                            <p className="m-0">Посмотреть</p>
                          </button> 
                          </div>
                      </div> 
                    </div>  
                  </>
                }   




                { order.approve_status === 'SENT' ?
                  <>
                    <div className="modal fade modal-xs" id="rejectContractModal" tabIndex="-1" aria-labelledby="rejectContractModalLabel" aria-hidden="true">
                      <div className="modal-dialog modal-dialog-scrollable modal-xs">
                        <div className="modal-content">
                          <div className="modal-header bg-light justify-content-between">
                            <div style={{width: "35px"}}></div>
                            <h2 className="modal-title fs-5 " id="orderModal2Label">Договор № {order.user ? order.user.username : ""}-{order.year}</h2>
                            <button type="button" className="btn-close mx-1" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div className="modal-body">
                            <p className="m-4 fs-5"  style={{'fontWeight': '500'}}>Укажите причину отклонения договора в комментарии:</p>
                            <div className="m-4">
                              <form>
                                <textarea className=""  style={{width: "415px"}} rows="4" placeholder="Комментарий для лаборатории" onChange={(e) => setRejectionComment(e.target.value)}/>
                              </form>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                            
                            {rejectionComment.length < 10 ?
                              <button type="button" className="btn btn-danger" disabled>Отклонить договор</button>
                            :
                              <button type="button" className="btn btn-danger" onClick={(e) => HandleReject(order)}>Отклонить договор</button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <button className="mt-4 btn btn-danger" onClick={() => console.log("вызвали модал")} data-bs-toggle="modal" data-bs-target="#rejectContractModal">
                      <p className="m-0">Отклонить договор</p>
                    </button> 


                    <div className="modal fade modal-xs" id="approveContractModal" tabIndex="-1" aria-labelledby="approveContractModalLabel" aria-hidden="true">
                      <div className="modal-dialog modal-dialog-scrollable modal-xs">
                        <div className="modal-content">
                          <div className="modal-header bg-light justify-content-between">
                            <div style={{width: "35px"}}></div>
                            <h2 className="modal-title fs-5 " id="orderModal2Label">Договор № {order.user ? order.user.username : ""}-{order.year}</h2>
                              {errorMessage.data ? 
                                <button type="button" className="btn-close mx-1" onClick={(e) => HandleCloseErrorMessage()} data-bs-dismiss="modal" aria-label="Close"></button>
                              :
                                <button type="button" className="btn-close mx-1" data-bs-dismiss="modal" aria-label="Close"></button>
                              }  
                          </div>
                          {errorMessage.data ? 
                            <>
                              <div className="modal-body">
                                <p className="m-4 fs-5"  style={{'fontWeight': '500'}}>Ошибка: <span className="text-danger">{errorMessage.data}</span></p>
                              </div>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={(e) => HandleCloseErrorMessage()} data-bs-dismiss="modal">Закрыть</button>
                              </div>
                            </>
                          :
                            <>
                              <div className="modal-body">
                                <p className="m-4 fs-5"  style={{'fontWeight': '500'}}>Вы уверены, что хотите утвердить и подписать договор?</p>    
                              </div>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                                <button type="button" className="btn btn-success px-4" onClick={(e) => HandleApprove(order)}><span className="m-2">Да</span></button>
                              </div>
                            </>
                          }
                        </div>
                      </div>
                    </div>

                    <button className="mt-4 ms-4 btn btn-success" onClick={() => console.log("вызвали модал")} data-bs-toggle="modal" data-bs-target="#approveContractModal">
                      <p className="m-0">Утвердить договор</p>
                    </button> 
                  </>
                : 
                  <></>  
                }

              </div>
              <div className="col-6">
                <p>Статус:</p>
                <p>
                  {(order.user_signed_contract_pdf && order.user_signed_order_form_pdf) ? 
                  <span className="text-success fw-semibold">получены документы</span> 
                  : 
                  <span className="fw-semibold">документов пока нет</span>}
                </p> 
                <p>
                  {order.sign_status === "NOT_SIGNED" && <span className="fw-semibold">{signStatusDisplay}</span>}
                  {order.sign_status === "SELLER_SIGNED" && <span className="fw-semibold">не подписан клиентом</span> }
                  {order.sign_status === "CLIENT_SIGNED" && <span className="text-success fw-semibold">{signStatusDisplay}</span> }
                  {order.sign_status === "BOTH_SIGNED" && <span className="text-success fw-semibold">{signStatusDisplay}</span> }
                </p>

                {order.user_signed_order_form_pdf && 
                  <>
                    <ViewDocumentModal
                      modalId="userSignedOrderModal"
                      headerText="Бланк заказа"
                      document={order["user_signed_order_form_pdf"]}
                    />

                    <div className="row">
                      <div className="col-10">
                        <div className="my-2 d-flex align-content-center bg-primary bg-opacity-10 rounded border">
                          <p className="m-3 flex-grow-1 align-content-center"><b>Бланк заказа</b></p>
                          <a className="align-content-center" href={media_url + order.user_signed_order_form_pdf} download>скачать pdf</a>        
                          <button className="m-3 p-2 lk-button" onClick={() => console.log("вызвали модал")} data-bs-toggle="modal" data-bs-target="#userSignedOrderModal">
                            <p className="m-0">Посмотреть</p>
                          </button> 
                          </div>
                      </div> 
                    </div>  
                  </>
                }

                {order.user_signed_contract_pdf && 
                  <>
                    <ViewDocumentModal
                      modalId="userSignedContractModal"
                      headerText="Договор"
                      document={order["user_signed_contract_pdf"]}
                    />

                    <div className="row">
                      <div className="col-10">
                        <div className="my-2 d-flex align-content-center bg-primary bg-opacity-10 rounded border">
                          <p className="m-3 flex-grow-1 align-content-center"><b>Договор</b></p>
                          <a className="align-content-center" href={media_url + order.user_signed_contract_pdf} download>скачать pdf</a>        
                          <button className="m-3 p-2 lk-button" onClick={() => console.log("вызвали модал")} data-bs-toggle="modal" data-bs-target="#userSignedContractModal">
                            <p className="m-0">Посмотреть</p>
                          </button> 
                          </div>
                      </div> 
                    </div>  
                  </> 
                }

                <ConfirmationModal
                  modalId="docsMarkSignedConfirmationModal"
                  headerText="Договор"
                  messageText={[
                    "Вы хотите отметить присланные документы как подписанные клиентом?"
                  ]}
                  confirmButtonText="Отметить" 
                  Action={(e) => HandleMarkDocsSigned(order)}
                />        

                {
                  (order.user_signed_contract_pdf && order.user_signed_order_form_pdf) &&
                  (order.sign_status === 'NOT_SIGNED' || order.sign_status === 'SELLER_SIGNED') ? 
                    <button className="mt-2 lk-button" onClick={() => console.log("вызвали модал")} data-bs-toggle="modal" data-bs-target="#docsMarkSignedConfirmationModal">
                      <p className="m-0">Отметить документы...</p>
                    </button> 
                      : 
                    <></>
                }

                <ConfirmationModal
                  modalId="uploadContractConfirmationModal"
                  headerText="Договор"
                  messageText={[
                    "Вы уверены, что хотите выгрузить договор в 1С?"
                  ]}
                  confirmButtonText="Выгрузить" 
                  Action={(e) => HandleUploadOrder(order)}
                />    

              </div> 
            </div>   
            </div>    
            <div class="card-footer">

            {order.sign_status === "BOTH_SIGNED" ?       
              <>
                {uploadStatus === false ? 
                  <button className="m-3 p-2 lk-button" onClick={() => console.log("вызвали модал")} data-bs-toggle="modal" data-bs-target="#uploadContractConfirmationModal">
                    выгрузить договор в 1С
                  </button>           
                :
                  <>
                    {uploadStatus === true ? <p className="text-success m-2"><b>Договор выгружен в 1С</b></p> : <div className="m-2">Проверка статуса...</div>}
                  </>
                }
              </>
            :
              <>
                <div className="m-2">выгрузка договора в 1С станет доступна после подписания договора двумя сторонами</div>
              </>  
            }    
            </div>
          </div>
        </div>
      </div>
    </>
  )
}